var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.052 31.3241L21.001 27.9918",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9487 31.3241L20.9997 27.9918",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9487 27.9918H24.0507",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0134 19.5597C35.0134 19.5597 24.8146 23.3267 25.2942 23.8051C35.0529 31.5611 35.8186 20.64 35.0134 19.5597Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0694 32.657L33.2046 29.3247",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0171 35.9893L30.1523 32.657",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34518 28.7298C3.52581 26.9576 3.0752 25.0214 3.0752 22.9934L5.74483 2L13.7976 8.86636C15.8937 8.09314 18.1991 7.66488 20.6185 7.66488H21.3812C23.8006 7.66488 26.1052 8.09314 28.2028 8.86636L36.2549 2.00006L38.9245 22.9934C38.9245 25.0215 38.4739 26.9577 37.6545 28.7299",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3379 36.0037C14.0306 37.4733 17.2112 38.3219 20.619 38.3219H21.3818C24.7896 38.3219 27.9709 37.4733 30.6629 36.0037",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98735 19.5597C6.98735 19.5597 16.4234 23.9931 16.7065 23.8051C7.28599 31.9678 6.03611 21.3319 6.98735 19.5597Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93115 32.657L8.79592 29.3247",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9834 35.9893L11.8482 32.657",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8473 23.9932C12.6898 23.9932 13.3728 23.3964 13.3728 22.6602C13.3728 21.9241 12.6898 21.3273 11.8473 21.3273C11.0048 21.3273 10.3218 21.9241 10.3218 22.6602C10.3218 23.3964 11.0048 23.9932 11.8473 23.9932Z",
    fill: "#5671A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1529 23.9932C30.9955 23.9932 31.6784 23.3964 31.6784 22.6602C31.6784 21.9241 30.9955 21.3273 30.1529 21.3273C29.3104 21.3273 28.6274 21.9241 28.6274 22.6602C28.6274 23.3964 29.3104 23.9932 30.1529 23.9932Z",
    fill: "#5671A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat4);
export default __webpack_public_path__ + "static/media/cat4.0c04ed8020ce47d216e8cb0c14a03083.svg";
export { ForwardRef as ReactComponent };